import { useDashboardSummary } from './lib/useDashboardSummary';
import React, { useState } from 'react';
import { Factory, Maximize2 } from 'lucide-react';
import { BarChart, Bar, ResponsiveContainer } from 'recharts';

import ProducaoTotal from './ProducaoTotal';
import { useProductionData } from './lib/useProductionData';
import AnnualOperationalTotal from './components/dashboard/AnnualOperationalTotal';

const apiBaseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5008';

const MiniChart = ({ color }) => {
  const data = Array.from({ length: 10 }, () => ({ val: Math.random() * 100 }));
  return (
    <div className="h-8 w-20 opacity-30">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <Bar dataKey="val" fill={color} radius={[1, 1, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

function StatBox({ title, icon: Icon, color, border, dia, mes, annual, year, onExpand }) {
  return (
    <div className={`relative bg-[#161b22] border-l-4 ${border} px-5 py-5 min-h-[200px] rounded shadow-xl flex flex-col justify-between h-full transition-all hover:bg-[#1c222a]`}>
      <button
        onClick={onExpand}
        aria-label="Ver detalhes de produção"
        className="absolute top-3 right-3 text-gray-600 hover:text-cyan-400 transition-colors z-20"
      >
        <Maximize2 size={18} />
      </button>

      <div className={`flex items-center gap-2 mb-2 ${color} font-black text-[10px] uppercase tracking-widest`}>
        <Icon size={20} /> <span>{title}</span>
      </div>
      <div className="flex justify-between items-end mb-2">
        <div>
          <p className="text-gray-500 text-[9px] font-bold uppercase mb-1 italic">Dia</p>
          <p className="text-white font-mono text-2xl font-bold italic tracking-tighter">
            R$ {Number(dia).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>
        <MiniChart color="#22d3ee" />
      </div>
      <div className="flex justify-between items-center">
        <p className="text-gray-500 text-[9px] font-bold uppercase italic">Mês</p>
        <p className={`${color} font-mono text-lg font-bold italic tracking-tighter`}>
          R$ {Number(mes).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
        </p>
      </div>
      <AnnualOperationalTotal rows={annual.rows} loading={annual.loading} error={annual.error} metric="ValorTotalRealizado" year={year} color={color} />

    </div>
  );
}


export default function Producao({ empresa = '', refreshSignal = 0, onOpenDashboard } = {}) {



  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, loading, error } = useDashboardSummary('/api/dashboard/producao', { empresa, refreshSignal });
  const year = new Date().getFullYear();
  const annual = useProductionData({ apiBaseUrl, company: empresa, refreshSignal, dataInicial: `${year}-01-01`, dataFinal: `${year}-12-31` });
  if (error) return <div role="alert" className="rounded border border-red-900 bg-[#161b22] p-4 text-xs text-red-300">{error}</div>;

  if (loading) return <div className="min-h-[200px] rounded border-l-4 border-cyan-500 bg-[#161b22] px-5 py-5">Carregando...</div>;

   

  return (
    <>
      <StatBox
        title="PRODUÇÃO"
        icon={Factory}
        color="text-cyan-400"
        border="border-cyan-500"
        dia={data?.producaoDia || 0}
        mes={data?.producaoMes || 0}
        annual={annual}
        year={year}
        onExpand={() => setIsModalOpen(true)}
      />

      {isModalOpen && (
        <ProducaoTotal
          data={data}
          onClose={() => setIsModalOpen(false)}
          onOpenDashboard={() => {
            setIsModalOpen(false);
            onOpenDashboard?.();
          }}
        />
      )}
    </>
  );
}
